function apply(wpd, wpdDocument, elementIds, dataEntryVM) {
	addXYGraphEditSidebar(
		wpdDocument,
		elementIds.editXYGraphSidebar,
		dataEntryVM,
	);
	addXYGraphAdjustPointsSidebar(
		wpdDocument,
		elementIds.editXYGraphAdjustPointsSidebar,
	);
	addXYGraphSetValuesDialog(wpdDocument);

	if (dataEntryVM.reworkXYGraphCalibration) {
		addXYGraphAlignAxesSidebar(wpdDocument, elementIds.xyGraphAlignAxesSidebar);
		replaceInfoPopupButton(wpdDocument, dataEntryVM);
		addCancelXyGraphCalibrationDialog(
			wpdDocument,
			elementIds.cancelXyGraphCalibrationDialog,
		);
		addCalibrateAxisValuesSidebar(
			wpdDocument,
			elementIds.calibrateAxisValuesSidebar,
		);
		addCalibrateAxisDataTypesSidebar(
			wpdDocument,
			elementIds.calibrateAxisDataTypesSidebar,
		);
		addCalibrateAxisStudyBranchesSidebar(
			wpdDocument,
			elementIds.calibrateAxisStudyBranchesSidebar,
		);
	}
}

function addXYGraphEditSidebar(wpdDocument, sidebarId, dataEntryVM) {
	// get the default calibration sidebar
	const axisSidebar = wpdDocument.getElementById("axes-calibration-sidebar");

	// insert table axis calibration sidebar
	axisSidebar.insertAdjacentHTML(
		"beforebegin",
		`
		<div id="${sidebarId}" class="sidebar" style="display: none;">
			<p class="sidebar-title">Edit XY Graph</p>
			<p align="left" style="font-weight: bold;">Axis Points</p>
			<p align="left">Edit the selected graph's axis points:</p>
			<p align="left" style="margin-top:5px">
				<input
					type="button"
					value="Adjust positions"
					style="display:block; margin-bottom: 5px; margin-top: 5px;"
					onclick="${
						dataEntryVM.reworkXYGraphCalibration
							? "wpd.xyGraphEdit.startAxisPointsCalibration(true);"
							: "wpd.xyGraphEdit.adjustAxisPoints();"
					}"
				>
				<input
					type="button"
					value="Set data types"
					style="display:block; margin-bottom: 5px; margin-top: 5px;"
					onclick="${
						dataEntryVM.reworkXYGraphCalibration
							? "wpd.xyGraphEdit.startDefineAxisDataTypes(true);"
							: "wpd.xyGraphEdit.openSetDataTypesDialog();"
					}"
				>
				<input
					type="button"
					value="Set values"
					style="display:block; margin-bottom: 5px; margin-top: 5px;"
					onclick="${
						dataEntryVM.reworkXYGraphCalibration
							? "wpd.xyGraphEdit.startDefineAxisValues(true);"
							: "wpd.xyGraphEdit.openSetAxisPointValuesDialog();"
					}"
				>
			</p>
			<p align="left" style="margin-top:20px; font-weight: bold;">Study Branches</p>
			<p align="left">Edit the study branches associated with the selected graph:</p>
			<p align="left" style="margin-top:5px">
				<input
					type="button"
					value="Set study branches"
					style="display:block; margin-bottom: 5px; margin-top: 5px;"
					onclick="${
						dataEntryVM.reworkXYGraphCalibration
							? "wpd.xyGraphEdit.startDefineAxisStudyBranches(true);"
							: "wpd.xyGraphEdit.openSetStudyBranchesDialog();"
					}"
				>
			</p>
			<p align="left" style="margin-top:30px;">Note that adjustments can impact existing extracted data for this graph.</p>
			<p align="left" style="margin-top:20px">
				<input
					type="button"
					value="Close"
					style="display:block; margin-bottom: 5px; margin-top: 5px;"
					onclick="wpd.xyGraphEdit.closeXYGraphEdit();"
				>
			</p>			
		</div>
	`,
	);
}

//TODO: remove when reworkXYGraphCalibration is deprecated
function addXYGraphAdjustPointsSidebar(wpdDocument, sidebarId) {
	// get the default calibration sidebar
	const axisSidebar = wpdDocument.getElementById("axes-calibration-sidebar");

	// insert table axis calibration sidebar
	axisSidebar.insertAdjacentHTML(
		"beforebegin",
		`
		<div id="${sidebarId}" class="sidebar" style="display: none;">
   			<p class="sidebar-title">Adjust Axis Points</p>
    		<p>Click points to select and use cursor keys to adjust positions. Use Shift+Arrow for faster movement. Click complete when finished.</p>
			<br>
			<p>Note that adjusting axis positions can impact the values of existing data points.</p>
    		<p align="center"><input type="button" value="Complete" style="width: 120px;" onclick="wpd.xyGraphEdit.completeAdjustAxisPoints();" /></p>
		</div>
	`,
	);
}

//TODO: remove when reworkXYGraphCalibration is deprecated
function addXYGraphSetValuesDialog(wpdDocument) {
	wpdDocument.getElementById("point-group-settings-popup").insertAdjacentHTML(
		"afterend",
		`
		<div id="xy-graph-set-values-dialog" class="popup" style="width: 650px; left: 533px; top: 60px;">
			<div class="popupheading">X and Y Axes Calibration</div>
			<p>&nbsp;</p>
			<p align="center">Enter X-values of the two points clicked on X-axis and Y-values of the two points clicked on Y-axes</p>
			<center>
				<table padding="10">
					<tr>
						<td></td>
						<td align="center" valign="bottom">Point 1</td>
						<td align="center" valign="bottom" width="80">Point 2</td>
						<td align="center" valign="bottom" width="82">Log Scale</td>
					</tr>
					<tr>
						<td align="center">X-Axis:</td>
						<td align="center"><input type="text" size="8" id="xy-edit-xmin" value="0" onfocus="wpd.xyGraphEdit.zoomCalibrationPoint(0);" /></td>
						<td align="center"><input type="text" size="8" id="xy-edit-xmax" value="1" onfocus="wpd.xyGraphEdit.zoomCalibrationPoint(1);" /></td>
						<td align="center"><input type="checkbox" id="xy-edit-xlog"></td>
					</tr>
					<tr>
						<td align="center">Y-Axis:</td>
						<td align="center"><input type="text" size="8" id="xy-edit-ymin" value="0" onfocus="wpd.xyGraphEdit.zoomCalibrationPoint(2);" /></td>
						<td align="center"><input type="text" size="8" id="xy-edit-ymax" value="1" onfocus="wpd.xyGraphEdit.zoomCalibrationPoint(3);" /></td>
						<td align="center"><input type="checkbox" id="xy-edit-ylog" /></td>
					</tr>
				</table>
				<span class="xy-edit-log-validation-message" hidden>Values on a log scale axis must be greater than 0, since log is undefined for zero and negative numbers</span>
				<span class="xy-edit-validation-message" hidden>Please enter valid values</span>
				<br />
				<p align="center"><label><input type="checkbox" id="xy-edit-axes-no-rotation" />Assume axes are perfectly aligned with image coordinates (skip rotation correction)</label></p>
				<br />
				<p align="center" class="footnote">*For dates, use yyyy/mm/dd hh:ii:ss format, where ii denotes minutes (e.g. 2013/10/23 or 2013/10 or 2013/10/23 10:15 or just 10:15). For exponents, enter values as 1e-3 for 10^-3.</p>
				<p>&nbsp;</p>
				<p align="center">Note that updating axis values will impact the values of existing data points.</p>
				<br />
				<p align="center">
					<input type="button" value="OK" onclick="wpd.xyGraphEdit.confirmSetAxisPointValues();" />
					<input type="button" value="Cancel" onclick="wpd.xyGraphEdit.closeSetAxisPointValuesDialog();" />
				</p>
			</center>
		</div>`,
	);
}

function addXYGraphAlignAxesSidebar(wpdDocument, sidebarId) {
	// get the default calibration sidebar
	const axisSidebar = wpdDocument.getElementById("axes-calibration-sidebar");

	// insert table axis calibration sidebar
	axisSidebar.insertAdjacentHTML(
		"beforebegin",
		`
			<div id="${sidebarId}" class="sidebar" style="display: none;">
				<p class="sidebar-title xy-graph-align-axes-sidebar-title">Define Axis Points
					<input
						type="button"
						value="info"
						onclick="wpd.xyGraphEdit.showXyAxesInfoPopup();"
					>
				</p>
				<p id="xy-graph-add-align-axes-sidebar-buttons" hidden align="center" style="margin-bottom: 10px;">
					<input id="xy-graph-add-align-axes-cancel-button" type="button" value="Cancel" style="width: 120px;" onclick="wpd.xyGraphEdit.showCancelXyGraphCalibrationDialog();" />
					<input id="xy-graph-add-align-axes-complete-button" type="button" disabled value="Next" style="width: 120px;" onclick="wpd.xyGraphEdit.completeAxisPointsCalibration(false);" />
				</p>
				<p id="xy-graph-edit-align-axes-sidebar-buttons" hidden align="center" style="margin-bottom: 10px;">
					<input id="xy-graph-edit-align-axes-complete-button" type="button" value="Complete" style="width: 120px;" onclick="wpd.xyGraphEdit.completeAxisPointsCalibration(true);" />
				</p>
				<p>Click four known points on the axes to define the axis points, in the following order:</p>
				<ul>
					<li>X1 (minimum X value)</li>
					<li>X2 (maximum X value)</li>
					<li>Y1 (minimum Y value)</li>
					<li>Y2 (maximum Y value)</li>
				</ul>
				<p>Use cursor keys to adjust positions.</p>
				<p>Use Shift+Arrow for faster movement.</p>
				<p>Click complete when finished.</p>
			</div>
		`,
	);
}

function replaceInfoPopupButton(wpdDocument) {
	const infoPopupButton = wpdDocument.getElementById("xyAxesInfo");
	const infoProceedButton = infoPopupButton.querySelector(
		"input[value='Proceed']",
	);
	infoProceedButton.outerHTML = `
		<input type="button" value="Close" onclick="wpd.xyGraphEdit.closeXyAxesInfoPopup();">
	`;
}

function addCancelXyGraphCalibrationDialog(wpdDocument, dialogId) {
	wpdDocument.getElementById("point-group-settings-popup").insertAdjacentHTML(
		"afterend",
		`
		<div id="${dialogId}" class="popup" style="width: 650px; left: 533px; top: 60px;">
			<div class="popupheading">Cancel XY Graph Creation</div>
			<p>&nbsp;</p>
			<p align="center">Are you sure you want to cancel graph creation?</p>
			<p>&nbsp;</p>
			<p align="center">
				<input type="button" value="Cancel" onclick="wpd.xyGraphEdit.closeCancelXyGraphCalibrationDialog(this);">
				<input type="button" value="OK" onclick="wpd.xyGraphEdit.cancelXyGraphCalibration(this);">
			</p>
		</div>`,
	);
}

function addCalibrateAxisValuesSidebar(wpdDocument, sidebarId) {
	wpdDocument.getElementById("axes-calibration-sidebar").insertAdjacentHTML(
		"beforebegin",
		`
		<div id="${sidebarId}" class="sidebar" style="display: none;">
			<p class="sidebar-title xy-graph-align-axes-sidebar-title">Define Axis Values</p>
			<p id="xy-graph-add-axis-values-sidebar-buttons" hidden align="center" style="margin-bottom: 10px;">
				<input id="xy-graph-add-axis-values-previous-button" type="button" value="Previous" style="width: 79px;" onclick="wpd.xyGraphEdit.startAxisPointsCalibration();" />
				<input id="xy-graph-add-axis-values-cancel-button" type="button" value="Cancel" style="width: 79px;" onclick="wpd.xyGraphEdit.showCancelXyGraphCalibrationDialog();" />
				<input id="xy-graph-add-axis-values-complete-button" type="button" value="Next" style="width: 79px;" onclick="wpd.xyGraphEdit.completeDefineAxisValues(false);" />
			</p>
			<p id="xy-graph-edit-axis-values-sidebar-buttons" hidden align="center" style="margin-bottom: 10px;">
				<input id="xy-graph-edit-axis-values-complete-button" type="button" value="Complete" style="width: 79px;" onclick="wpd.xyGraphEdit.completeDefineAxisValues(true);" />
			</p>
			<p>Enter X-values of the two points clicked on X-axis and Y-values of the two points clicked on Y-axes:</p>
			<br>
			<table padding="10">
				<tr>
					<td></td>
					<td align="center" valign="bottom">Point 1</td>
					<td align="center" valign="bottom" width="80">Point 2</td>
					<td align="center" valign="bottom" width="82">Log Scale</td>
				</tr>
				<tr>
					<td align="center" width="80">X-Axis:</td>
					<td align="center"><input type="text" size="6" id="xy-xmin" value="0" onfocus="wpd.xyGraphEdit.zoomCalibrationPoint(0);" /></td>
					<td align="center"><input type="text" size="6" id="xy-xmax" value="1" onfocus="wpd.xyGraphEdit.zoomCalibrationPoint(1);" /></td>
					<td align="center"><input type="checkbox" id="xy-xlog"></td>
				</tr>
				<tr>
					<td align="center" width="80">Y-Axis:</td>
					<td align="center"><input type="text" size="6" id="xy-ymin" value="0" onfocus="wpd.xyGraphEdit.zoomCalibrationPoint(2);" /></td>
					<td align="center"><input type="text" size="6" id="xy-ymax" value="1" onfocus="wpd.xyGraphEdit.zoomCalibrationPoint(3);" /></td>
					<td align="center"><input type="checkbox" id="xy-ylog" /></td>
				</tr>
			</table>
			<span class="xy-log-validation-message" hidden>Values on a log scale axis must be greater than 0, since log is undefined for zero and negative numbers</span>
			<span class="xy-validation-message" hidden>Please enter valid values</span>
			<br>
			<p align="center">
				<label style="display: inline-flex; align-items: center; gap: 8px;">
					<input type="checkbox" id="xy-axes-no-rotation" checked>
					<span>This document is properly aligned (computer generated or well-scanned)</span>
				</label>
			</p>
			<br>
			<p align="center" class="sidebar-footnote">
				*For dates, use yyyy/mm/dd hh:ii:ss format, where ii denotes minutes (e.g. 2013/10/23 or 2013/10 or 2013/10/23 10:15 or just 10:15). For exponents, enter values as 1e-3 for 10^-3
			</p>
		</div>
		`,
	);
}

function addCalibrateAxisDataTypesSidebar(wpdDocument, sidebarId) {
	wpdDocument.getElementById("axes-calibration-sidebar").insertAdjacentHTML(
		"beforebegin",
		`
		<div id="${sidebarId}" class="sidebar" style="display: none;">
			<p class="sidebar-title xy-graph-align-axes-sidebar-title">Define Axis Data Types</p>
			<p id="xy-graph-add-data-types-sidebar-buttons" hidden align="center" style="margin-bottom: 10px;">
				<input id="xy-graph-add-data-types-previous-button" type="button" value="Previous" style="width: 79px;" onclick="wpd.xyGraphEdit.startDefineAxisValues(false);" />
				<input id="xy-graph-add-data-types-cancel-button" type="button" value="Cancel" style="width: 79px;" onclick="wpd.xyGraphEdit.showCancelXyGraphCalibrationDialog();" />
				<input id="xy-graph-add-data-types-complete-button" type="button" value="Next" style="width: 79px;" onclick="wpd.xyGraphEdit.completeDefineAxisDataTypes(false);" />
			</p>
			<p id="xy-graph-edit-data-types-sidebar-buttons" hidden align="center" style="margin-bottom: 10px;">
				<input id="xy-graph-edit-data-types-complete-button" type="button" value="Complete" style="width: 79px;" onclick="wpd.xyGraphEdit.completeDefineAxisDataTypes(true);" />
			</p>
			<!-- X-Axis Section -->
			<p class="sidebar-title" style="display: flex; justify-content: space-between; align-items: center;">
				<span>↔ X-Axis</span>
				<span style="display: inline-flex; align-items: center; gap: 4px;">
					<label style="font-size: 0.8em; white-space: nowrap; margin: 0;">Pt Groups</label>
					<input type="button" value="⚙" onclick="wpd.pointGroups.showSettingsPopup('x');" style="padding: 2px 8px;" />
				</span>
			</p>
			<div class="axis-data-type-input">
				<label style="font-size: 0.9em;">Data type <span class="error-message" style="color: red;"></span></label>
				<input type="text" class="axis-data-type" id="add-x-axis-data-type" placeholder="e.g. Time" style="width: 240px;" />
			</div>
			<div style="display: grid; grid-template-columns: 1fr 1fr; gap: 6px;">
				<div class="axis-data-type-input">
					<label style="font-size: 0.9em;">Unit <span class="error-message"></span></label>
					<input type="text" class="axis-unit" id="add-x-axis-unit" placeholder="e.g. Weeks" style="width: 170px;" />
				</div>
				<div class="axis-data-type-input">
					<label style="font-size: 0.9em;">Decimals <span class="error-message"></span></label>
					<input type="number" class="axis-decimals" id="add-x-axis-decimals" value="2" style="width: 56px;" />
				</div>
			</div>
			<div class="axis-data-type-input">
				<label style="font-size: 0.9em;">Description <span class="error-message"></span></label>
				<input type="text" class="axis-description" id="add-x-axis-description" style="width: 240px;" />
			</div>
			<div class="axis-data-type-input" style="margin-bottom: 10px;">
				<label style="font-size: 0.9em;">Ratio type <span class="error-message"></span></label>
				<select class="axis-change-from-baseline" id="add-x-axis-change-from-baseline" style="width: 240px;"></select>
				<span class="ratio-type-other" style="display: none; align-items: center; width: 240px;">
					<button type="button" class="ratio-type-back" title="Back to list" style="cursor: pointer; flex-shrink: 0; margin-right: 2px;">&#8592;</button>
					<input type="text" class="ratio-type-custom" placeholder="Custom ratio type" style="flex: 1; min-width: 0;" />
				</span>
			</div>
		
			<!-- Y-Axis Section -->
			<p class="sidebar-title" style="display: flex; justify-content: space-between; align-items: center;">
				<span>↕ Y-Axis</span>
				<span style="display: inline-flex; align-items: center; gap: 4px;">
					<label style="font-size: 0.8em; white-space: nowrap; margin: 0;">Pt Groups</label>
					<input type="button" value="⚙" onclick="wpd.pointGroups.showSettingsPopup('y');" style="padding: 2px 8px;" />
				</span>
			</p>
			<div class="axis-data-type-input">
				<label style="font-size: 0.9em;">Data type <span class="error-message" style="color: red;"></span></label>
				<input type="text" class="axis-data-type" id="add-y-axis-data-type" style="width: 240px;" />
			</div>
			<div style="display: grid; grid-template-columns: 1fr 1fr; gap: 6px;">
				<div class="axis-data-type-input">
					<label style="font-size: 0.9em;">Unit <span class="error-message"></span></label>
					<input type="text" class="axis-unit" id="add-y-axis-unit" style="width: 170px;" />
				</div>
				<div class="axis-data-type-input">
					<label style="font-size: 0.9em;">Decimals <span class="error-message"></span></label>
					<input type="number" class="axis-decimals" id="add-y-axis-decimals" value="2" style="width: 56px;" />
				</div>
			</div>
			<div class="axis-data-type-input">
				<label style="font-size: 0.9em;">Description <span class="error-message"></span></label>
				<input type="text" class="axis-description" id="add-y-axis-description" style="width: 240px;" />
			</div>
			<div class="axis-data-type-input">
				<label style="font-size: 0.9em;">Ratio type <span class="error-message"></span></label>
				<select class="axis-change-from-baseline" id="add-y-axis-change-from-baseline" style="width: 240px;"></select>
				<span class="ratio-type-other" style="display: none; align-items: center; width: 240px;">
					<button type="button" class="ratio-type-back" title="Back to list" style="cursor: pointer; flex-shrink: 0; margin-right: 2px;">&#8592;</button>
					<input type="text" class="ratio-type-custom" placeholder="Custom ratio type" style="flex: 1; min-width: 0;" />
				</span>
			</div>

			<!-- Broadcast tags section -->
			<p class="sidebar-title" style="margin-top: 12px;">Default tags applied to every data point</p>
			<div class="broadcast-tags-section" data-context="sidebar-xy">
				<div class="broadcast-tags-help">Each tag below will be added to every extracted data point. Leave the value blank to fill it in for each point.</div>
				<div id="add-broadcast-tags-rows" class="broadcast-tags-rows"></div>
				<div style="text-align: center; margin-top: 4px;">
					<a href="#" class="broadcast-tag-add-link" onclick="wpd.alignAxes.addBroadcastTagRow(this); return false;">+ Add tag</a>
				</div>
			</div>

		</div>
		`,
	);
}

function addCalibrateAxisStudyBranchesSidebar(wpdDocument, sidebarId) {
	wpdDocument.getElementById("axes-calibration-sidebar").insertAdjacentHTML(
		"beforebegin",
		`
		<div id="${sidebarId}" class="sidebar" style="display: none;">
			<p class="sidebar-title xy-graph-align-axes-sidebar-title">Define Study Branches</p>
			<p id="xy-graph-add-study-branches-sidebar-buttons" hidden align="center" style="margin-bottom: 10px;">
				<input id="xy-graph-add-study-branches-previous-button" type="button" value="Previous" style="width: 79px;" onclick="wpd.xyGraphEdit.startDefineAxisDataTypes(false);" />
				<input id="xy-graph-add-study-branches-cancel-button" type="button" value="Cancel" style="width: 79px;" onclick="wpd.xyGraphEdit.showCancelXyGraphCalibrationDialog();" />
				<input id="xy-graph-add-study-branches-complete-button" type="button" value="Next" style="width: 79px;" onclick="wpd.xyGraphEdit.completeDefineAxisStudyBranches(false);" />
			</p>
			<p id="xy-graph-edit-study-branches-sidebar-buttons" hidden align="center" style="margin-bottom: 10px;">
				<input id="xy-graph-edit-study-branches-complete-button" type="button" value="Complete" style="width: 79px;" onclick="wpd.xyGraphEdit.completeDefineAxisStudyBranches(true);" />
			</p>
			<div id="add-axis-study-branch-inputs" style="margin-bottom: 5px;">
				<div class="add-dataset-row" data-index="0" style="display: block; margin-bottom: 0px padding-top: 0px;">
					<div style="font-size: 0.9em; font-weight: bold;">
						Study Branch <span class="add-dataset-number">1</span>
					</div>

					<div class="add-dataset-row-actions" style="display: block;">
						<label style="font-size: 0.9em; display: block;">Study branch</label>
						<input
							type="text"
							class="add-dataset-study-arm-input"
							data-type="composite-key"
							placeholder="Study branch"
							style="width: 240px;"
						/>

						<div style="display: flex; align-items: flex-end; gap: 6px;">
							<div style="flex: 1;">
								<label style="font-size: 0.9em; display: block;">Tag group</label>
								<input
									type="text"
									class="add-dataset-tag-group-input"
									data-type="tag-group"
									placeholder="Tag group"
									style="width: 100%;"
								/>
							</div>
							<span id="add-dataset-same-tag-groups-container" class="add-dataset-same-tag-groups-container" style="display: flex; flex-direction: column; align-items: center;">
								<label style="font-size: 0.7em; white-space: nowrap; margin: 0 0 2px 0;">Same for all</label>
								<input
									type="checkbox"
									id="add-dataset-same-tag-groups-checkbox"
									class="add-dataset-same-tag-groups-checkbox"
								/>
							</span>
						</div>
						<span class="uneditable-message" style="display: block; font-size: 0.85em; color: #666;"></span>
						<span class="error-message" style="display: block; font-size: 0.85em; color: red;"></span>
					</div>
				</div>
			</div>
			<div style="text-align: center; margin-bottom: 10px;">
				<a href="#" title="Shift + Enter" onclick="wpd.dataSeriesManagement.addRow(false, true);">+ Add another study branch</a>
			</div>
		</div>
		`,
	);
}

export { apply };
